var _rect, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 188,
    viewBox: "0 0 352 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 188,
    fill: "#082C4E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5812 48.9906C95.8868 48.9906 100.998 43.844 100.998 37.4953C100.998 31.1466 95.8868 26 89.5812 26C83.2757 26 78.1641 31.1466 78.1641 37.4953C78.1641 43.844 83.2757 48.9906 89.5812 48.9906Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1957 51.2635H80.9667C80.3185 51.2493 79.6911 51.4945 79.222 51.9452C78.753 52.396 78.4806 53.0156 78.4646 53.6682V60.7857C78.4577 61.1096 78.3876 61.429 78.2582 61.7256C78.1287 62.0222 77.9425 62.2902 77.7101 62.5144C77.4778 62.7385 77.2038 62.9143 76.9039 63.0319C76.6041 63.1494 76.2841 63.2062 75.9624 63.1992H60.2846C59.6439 63.1967 59.0277 63.4471 58.5681 63.8966C58.1085 64.3461 57.8422 64.9591 57.8262 65.604V72.6509C57.8101 73.3036 57.5377 73.9232 57.0687 74.3739C56.5997 74.8247 55.9723 75.0699 55.324 75.0557H46.3303C46.0078 75.0487 45.6872 75.1058 45.3868 75.2239C45.0863 75.342 44.812 75.5186 44.5795 75.7437C44.347 75.9687 44.161 76.2378 44.0321 76.5354C43.9031 76.8331 43.8338 77.1534 43.8281 77.4781V84.5955C43.8442 85.2504 44.1175 85.8723 44.5882 86.3247C45.0588 86.7771 45.6885 87.0232 46.339 87.009H97.1957C97.8463 87.0232 98.4759 86.7771 98.9466 86.3247C99.4172 85.8723 99.6906 85.2504 99.7066 84.5955V53.6682C99.6987 53.3443 99.6274 53.0251 99.4969 52.729C99.3664 52.4328 99.1792 52.1654 98.946 51.9421C98.7129 51.7187 98.4383 51.5439 98.1379 51.4274C97.8376 51.311 97.5174 51.2553 97.1957 51.2635Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8937 79.1334C38.6749 73.4518 41.7895 62.6524 45.744 60.2212C53.1979 55.6143 55.5339 73.4342 51.177 73.3726C45.779 73.3726 50.3021 60.5031 53.9853 55.1915C63.0053 42.3044 71.6141 47.6953 73.1801 52.3639C74.3875 55.9666 73.3814 61.5073 70.6692 61.4368C67.6509 61.3575 67.1085 56.5744 68.2021 52.8748C70.363 45.5372 76.8896 39.1509 81.2378 36.7285",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 45.8815C84.5284 47.6452 87.3009 48.535 90.1155 48.3832C93.9475 48.3039 96.1171 46.8857 98.3656 44.7188",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.401 154.405C125.565 154.405 135.426 144.501 135.426 132.284C135.426 120.066 125.565 110.162 113.401 110.162C101.236 110.162 91.375 120.066 91.375 132.284C91.375 144.501 101.236 154.405 113.401 154.405Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5117 167.116C100.681 164.073 117.529 158.801 116.798 155.387C116.014 151.469 106.141 155.803 102.002 157.315",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.277 156.387C107.482 152.628 117.69 143.013 116.043 141.35C113.964 139.272 105.475 148.55 101.194 151.319C104.594 147.321 114.061 137.697 112.3 136.105C111.498 135.38 109.869 136.035 107.949 137.352C106.424 138.432 104.973 139.614 103.608 140.89C101.296 143.021 99.108 145.283 97.0553 147.666C100.032 144.19 106.575 135.53 105.096 134.266C102.938 132.435 97.6366 139.758 94.3164 144.252",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8789 156.369L84.7138 151.062C84.7138 151.062 93.318 134.257 98.2938 134.752",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.879 111.127C132.538 112.595 130.882 112.984 125.712 111.525C123.634 110.941 116.104 114.426 115.074 112.524C114.193 110.808 118.597 108.42 123.625 105.749C126.461 104.237 127.377 102.308 128.671 99.8848",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.848 133.911C126.794 135.503 133.126 130.939 134.377 129.993C142.144 124.138 145.825 117.778 149.101 108.42",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.85 111.463C120.975 116.133 113.013 120.724 109.491 124.943C109.343 125.119 109.246 125.331 109.209 125.558C109.171 125.785 109.195 126.017 109.278 126.232C109.361 126.446 109.499 126.634 109.679 126.776C109.859 126.918 110.074 127.009 110.301 127.039C111.827 127.082 113.332 126.669 114.625 125.854C118.312 123.798 121.818 121.431 125.105 118.778C122.859 121.369 119.953 123.112 113.92 128.26C112.573 129.409 114.14 130.568 115.611 130.32C118.799 129.763 124.753 125.65 127.941 123.165C124.779 126.464 117.804 130.055 118.121 131.93C118.614 135.15 128.073 129.754 131.595 126.42",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.633 61.0494C299.324 61.0494 306.368 54.0467 306.368 45.4085C306.368 36.7702 299.324 29.7676 290.633 29.7676C281.943 29.7676 274.898 36.7702 274.898 45.4085C274.898 54.0467 281.943 61.0494 290.633 61.0494Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.289 46.2703C285.924 47.5225 286.878 48.5875 288.056 49.3588C289.233 50.1302 290.594 50.581 292.002 50.6663C293.406 50.6954 294.781 50.2656 295.916 49.4429C297.05 48.6201 297.882 47.45 298.282 46.1121",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.957 44.8284C297.992 44.689 299.043 44.9229 299.92 45.4878",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.809 44.5645L283.59 46.613C284.704 45.892 285.695 45.2854 286.809 44.5645Z",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.819 42.7712C270.468 42.5077 269.176 42.0012 268.007 41.2766C267.424 40.9083 266.922 40.4249 266.534 39.8563C266.146 39.2877 265.88 38.6459 265.752 37.9708C265.651 37.3678 265.757 36.7487 266.052 36.2124C266.707 35.1046 268.193 34.8497 269.493 34.8145C273.635 34.732 277.731 35.6939 281.398 37.6104C275.083 30.5768 275.64 24.862 276.852 23.7103C279.567 21.0727 282.575 24.9851 283.273 26.0489C284.948 28.7811 286.209 31.7435 287.015 34.8409C287.528 31.5175 288.633 24.4224 291.667 21.7233C292.11 21.3316 292.65 21.0647 293.232 20.9503C293.814 20.8359 294.415 20.8782 294.975 21.0727C296.417 21.609 297.116 23.2531 297.301 24.7653C297.752 28.4755 296.09 32.0802 294.471 35.4475C296.924 33.0431 299.738 31.0322 302.812 29.4866C307.039 27.4381 308.41 29.4338 308.817 30.2339C310.471 33.5397 303.563 39.7732 301.405 41.6635C304.837 41.0744 314 42.8855 313.054 47.0002C312.329 50.1389 303.891 50.0686 300.839 50.1389C303.493 51.1764 308.879 54.6404 308.313 57.7967C307.659 61.4717 300.883 58.9045 295.161 53.6557C296.479 55.4141 299.964 62.7114 295.922 64.6632C294.674 65.2611 292.64 64.1885 291.145 62.1751C289.65 60.1617 288.828 57.278 288.35 54.6931C287.466 59.6518 282.283 67.3448 277.94 65.2435C273.915 63.3181 279.284 54.3854 281.23 51.4401C278.86 54.0074 271.501 58.0341 268.847 55.7042C266.194 53.3743 270.201 47.2112 275.039 44.7318C275.401 44.5384 277.427 43.2988 277.427 43.2988C277.427 43.2988 273.049 43.0526 271.819 42.7712Z",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.395 56.3811C288.395 56.3811 289.606 68.3821 291.296 78.0973",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.883 73.9389C266.652 73.9389 274.665 74.0532 276.443 73.7894C277.266 73.6663 280.406 69.9649 282.714 69.1121C285.023 68.2593 286.252 68.7164 287.411 69.7275C291.143 72.9454 290.436 80.7702 289.843 84.1375C289.843 84.2958 289.392 86.9334 287.579 86.7751C285.191 86.5377 284.58 78.8624 284.333 77.104C284.173 80.9548 283.041 86.0278 280.202 87.5137",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.562 72.3826C292.718 72.1267 295.889 72.1267 299.044 72.3826C304.431 73.0419 305.439 78.071 301.583 79.4161C299.433 80.1722 294.348 80.6558 292.402 79.8645C290.633 79.1611 291.385 76.8577 293.198 76.2862C296.736 75.1696 298.443 75.407 298.443 75.407",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.527 79.5127C301.934 79.5684 302.315 79.7429 302.623 80.014C302.93 80.2852 303.15 80.6408 303.254 81.036C303.358 81.4312 303.342 81.8482 303.208 82.2343C303.074 82.6205 302.827 82.9584 302.5 83.2053C300.253 85.1308 296.211 85.1044 292.16 84.6208",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.84 84.322C303.9 86.1683 301.123 88.7883 298.354 89.395C296.355 89.7508 294.304 89.706 292.322 89.2631",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.488 93.8262C296.001 93.9317 301.087 93.879 301.166 90.7139",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.094 94.2212C271.278 94.2212 276.01 93.7992 279.15 94.3443C282.024 94.8367 286.809 97.4215 291.426 95.2851",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.043 28.5623C170.043 28.5623 178.431 25.5661 181.963 23.9934C182.124 23.9203 182.299 23.8808 182.476 23.8772C182.653 23.8737 182.829 23.9061 182.993 23.9727C183.158 24.0392 183.307 24.1385 183.431 24.2644C183.556 24.3903 183.654 24.5402 183.719 24.7051L186.302 31.0752C186.371 31.2398 186.407 31.4167 186.406 31.5953C186.405 31.7739 186.369 31.9506 186.298 32.1147C186.228 32.2788 186.125 32.427 185.995 32.5503C185.866 32.6736 185.713 32.7696 185.546 32.8325L173.82 37.3047L170.043 28.5623Z",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.421 87.0001C195.496 87.0001 205.284 77.2089 205.284 65.1308C205.284 53.0527 195.496 43.2615 183.421 43.2615C171.347 43.2615 161.559 53.0527 161.559 65.1308C161.559 77.2089 171.347 87.0001 183.421 87.0001Z",
    fill: "#3098F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.14 62.1962C158.17 63.9096 150.063 68.9793 150.941 71.8612C151.74 74.4268 159.453 74.172 162.72 73.6888C170.749 72.5448 178.64 70.581 186.269 67.8283C194.038 65.1707 201.517 61.7292 208.589 57.557C212.103 55.4219 217.276 51.4065 211.549 50.5279C207.676 50.0852 203.758 50.2512 199.937 51.0199",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.055 28.7812C172.69 34.9317 174.271 41.1876 176.871 47.549",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.595 162H208.981C208.479 162.004 207.982 161.901 207.524 161.697C207.065 161.493 206.656 161.193 206.323 160.817C205.99 160.442 205.741 159.999 205.593 159.519C205.446 159.039 205.402 158.534 205.466 158.036L219.525 111.447C219.635 110.594 220.053 109.811 220.701 109.246C221.349 108.681 222.181 108.372 223.04 108.379H226.309C227.177 108.374 228.016 108.689 228.664 109.266C229.313 109.842 229.726 110.637 229.824 111.5L243.092 158.044C243.155 158.54 243.111 159.044 242.964 159.521C242.816 159.998 242.569 160.439 242.238 160.813C241.907 161.188 241.5 161.487 241.044 161.692C240.589 161.896 240.095 162.001 239.595 162Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.312 107.07L252.213 99.8792",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.555 121.125C219.395 123.059 230.343 123.244 232.83 120.8",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.715 130.988C218.514 134.504 234.129 133.054 235.86 130.988",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.016 140.736C215.474 145.131 237.872 142.89 239.34 140.736",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 151.302C211.257 154.282 236.634 154.493 242.943 150.784",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.851 112.775C223.331 113.11 225.843 113.131 228.328 112.836C228.591 112.802 228.842 112.707 229.06 112.557C229.278 112.408 229.458 112.208 229.584 111.976C229.71 111.743 229.779 111.484 229.785 111.219C229.792 110.955 229.735 110.692 229.62 110.454L227.625 106.322C227.47 106.016 227.232 105.758 226.939 105.578C226.646 105.398 226.309 105.303 225.965 105.303H223.329C222.981 105.299 222.639 105.394 222.342 105.576C222.045 105.758 221.805 106.02 221.65 106.331L219.594 110.428C219.485 110.662 219.431 110.918 219.438 111.177C219.445 111.435 219.512 111.688 219.634 111.916C219.756 112.144 219.93 112.34 220.141 112.489C220.352 112.638 220.595 112.736 220.851 112.775V112.775Z",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.945 112.607C229.604 113.196 255.104 116.264 255.104 116.264",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 61,
    fill: "white",
    transform: "translate(38 26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 69,
    fill: "white",
    transform: "translate(79 99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 77,
    fill: "white",
    transform: "translate(264 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    fill: "white",
    transform: "translate(150 23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 63,
    fill: "white",
    transform: "translate(205 99)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDesktop);
export default __webpack_public_path__ + "static/media/icons-desktop.7207dec0a9155d8aaad0a9a9a5293b03.svg";
export { ForwardRef as ReactComponent };